import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Terms } from '@/components/Terms';

export const TermsSection = () => {
  const { t } = useTranslation('jackpot');

  const termsContent = useMemo(
    () => (
      <>
        {Object.values(t('terms', { returnObjects: true })).map(
          (rule: string, index) => (
            <p key={index}>{rule}</p>
          )
        )}
      </>
    ),
    [t]
  );

  return <Terms termsTextComponent={termsContent} termsTitle={t('tnc')} />;
};
